'use client';

import React, { useEffect, useRef, useState } from 'react';

interface ActivityItem {
  name: string;
  amount: string;
  status: string;
  statusColor: string;
  dot: string;
}

const ACTIVITIES: ActivityItem[] = [
  { name: 'María Beltrán', amount: '1.000 USD', status: 'Proceso Entregado', statusColor: '#4ade80', dot: '●' },
  { name: 'Nelson Francisco Ahuman', amount: '112.000 USD', status: 'Proceso Pendiente', statusColor: '#facc15', dot: '●' },
  { name: 'Carlos Mendoza', amount: '45.500 USD', status: 'Proceso Entregado', statusColor: '#4ade80', dot: '●' },
  { name: 'Lucía Fernández', amount: '8.750 USD', status: 'En Revisión', statusColor: '#60a5fa', dot: '●' },
  { name: 'Roberto Salinas', amount: '230.000 USD', status: 'Proceso Entregado', statusColor: '#4ade80', dot: '●' },
  { name: 'Ana Patricia Gómez', amount: '17.300 USD', status: 'Proceso Pendiente', statusColor: '#facc15', dot: '●' },
  { name: 'Jorge Luis Vargas', amount: '62.000 USD', status: 'Proceso Entregado', statusColor: '#4ade80', dot: '●' },
  { name: 'Valentina Ríos', amount: '5.200 USD', status: 'En Revisión', statusColor: '#60a5fa', dot: '●' },
  { name: 'Miguel Ángel Torres', amount: '89.400 USD', status: 'Proceso Entregado', statusColor: '#4ade80', dot: '●' },
  { name: 'Sandra Milena Cruz', amount: '33.600 USD', status: 'Proceso Pendiente', statusColor: '#facc15', dot: '●' },
  { name: 'Andrés Felipe Mora', amount: '150.000 USD', status: 'Proceso Entregado', statusColor: '#4ade80', dot: '●' },
  { name: 'Diana Marcela Ruiz', amount: '22.800 USD', status: 'En Revisión', statusColor: '#60a5fa', dot: '●' },
];

export default function LiveActivityTicker() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [isPaused, setIsPaused] = useState(false);

  // Duplicate items for seamless infinite scroll
  const items = [...ACTIVITIES, ...ACTIVITIES];

  return (
    <div className="bg-[#0f0f1e] border-y border-[#c9a84c]/20 py-3 overflow-hidden relative">
      {/* Left fade */}
      <div className="absolute left-0 top-0 bottom-0 w-16 z-10 bg-gradient-to-r from-[#0f0f1e] to-transparent pointer-events-none" />
      {/* Right fade */}
      <div className="absolute right-0 top-0 bottom-0 w-16 z-10 bg-gradient-to-l from-[#0f0f1e] to-transparent pointer-events-none" />

      {/* Live label */}
      <div className="absolute left-0 top-0 bottom-0 z-20 flex items-center">
        <div className="bg-[#c9a84c] px-3 py-1 flex items-center gap-1.5 h-full">
          <span className="w-1.5 h-1.5 rounded-full bg-[#1a1a2e] animate-pulse" />
          <span className="text-[#1a1a2e] text-[10px] font-black uppercase tracking-[0.15em] whitespace-nowrap">
            En Vivo
          </span>
        </div>
      </div>

      {/* Scrolling track */}
      <div
        className="pl-24"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div
          ref={trackRef}
          className="flex gap-0 whitespace-nowrap"
          style={{
            animation: isPaused
              ? 'none' :'tickerScroll 55s linear infinite',
          }}
        >
          {items.map((item, idx) => (
            <div
              key={idx}
              className="inline-flex items-center gap-2 px-6 border-r border-white/10 last:border-r-0"
            >
              {/* Status dot */}
              <span
                className="text-[8px] leading-none"
                style={{ color: item.statusColor }}
              >
                {item.dot}
              </span>
              {/* Name */}
              <span className="text-white/80 text-xs font-semibold">
                {item.name}
              </span>
              {/* Amount */}
              <span className="text-[#c9a84c] text-xs font-bold">
                {item.amount}
              </span>
              {/* Separator */}
              <span className="text-white/20 text-xs">—</span>
              {/* Status */}
              <span
                className="text-xs font-medium"
                style={{ color: item.statusColor }}
              >
                {item.status}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        @keyframes tickerScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>
  );
}
